import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { List } from 'foundations-components/transitional/components/List';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { getIsNonHubSpotFormsEnabled } from 'FormsUI/selectors/leadinSettings';
import { FormType } from 'FormsUI/components/dashboard/frameworkTable/types';
import { formStatusToI18nText, formTypeToI18nText } from 'FormsUI/components/dashboard/frameworkTable/utils';
import { isUngatedForNewEditorAccess } from 'FormsUI/selectors/Gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormsStatusTag = ({
  formType,
  isPublished,
  status,
  isFormTypeShown,
  isBeta,
  isNewEditor,
  isLegacy
}) => {
  const ungatedForNewEditorAccess = useSelector(isUngatedForNewEditorAccess);
  const nonHubSpotFormsTurnedOn = useSelector(getIsNonHubSpotFormsEnabled);
  const isActiveNonHubSpotForm = formType === FormType.CAPTURED && nonHubSpotFormsTurnedOn;
  const statusTagUse = isActiveNonHubSpotForm || isPublished ? 'success' : 'default';
  return /*#__PURE__*/_jsx(StatusTag, {
    use: statusTagUse,
    maxBlockSize: "16px",
    children: /*#__PURE__*/_jsxs(List, {
      inline: true,
      use: "inline-divided",
      wrapChildren: true,
      children: [formStatusToI18nText(status, formType, nonHubSpotFormsTurnedOn), isFormTypeShown && /*#__PURE__*/_jsxs(TFlex, {
        gap: 5,
        children: [formTypeToI18nText(formType, ungatedForNewEditorAccess), isBeta && !isNewEditor && !isLegacy && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.frameworkTable.columns.name.betaLabel"
        }), isLegacy && !isNewEditor && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.frameworkTable.columns.name.legacyLabel"
        })]
      })]
    })
  });
};
export default FormsStatusTag;